module.exports = __webpack_public_path__ + "img/204318-14-9.7c434659.png";